import Base from 'netxcore@netx/core-asset/collections/assets';
import {isMobile} from '@netx/core-next/utils/browser';
import {systemFacets} from '@netx/core-search/properties/search';
import {escapeURI} from '@netx/core/utils/escapeURI';
import {unescapeURI} from '@netx/core/utils/unescapeURI';

/** @override */
export default class Assets extends Base {
	get isSyncing() {
		return this._rpc && this.syncing;
	}
	// gross, for now overriding the whole read
	// parser to filter and sort facets
	/** @override */
	get parsers() {
		return {
			...super.parsers,
			read(result, opts) {
				// Did we fetch faceted, or normal?
				const facetedResult = this.useFacetedSearch();
				let assets = result.results || result;

				// DAM-15036 - Omit any assets without valid assetIds
				assets = _.filter(assets, (a) => {
					if (!a.assetId) {
						console.log('server returned a bogus asset');
					}
					return a.assetId;
				});

				// Check length of results; did we reach the end yet?
				if (assets.length > this.chunkSize) {
					assets.pop();
					this.lastChunk = false;
				} else {
					this.lastChunk = true;
				}

				// Don't remove existing assets if we are doing a chunk fetch.
				// (This options object will be passed to set.)
				opts.remove = !opts.chunk;

				if (facetedResult) {
					const portalAttrIds = Netx.attributes.ids();
					result.facets = result.facets.filter((facetOb) =>
						portalAttrIds.includes(facetOb.id),
					);
					result.facets.sort(function (a, b) {
						return portalAttrIds.indexOf(a.id) - portalAttrIds.indexOf(b.id);
					});

					const systemFacetLabels = systemFacets;
					const facets = _.map(result.facets, (facet) =>
						_.extend(facet, {
							title: systemFacetLabels[facet.label] || facet.label,
						}),
					);

					// Only return facets that have options with a count
					this.selection.searchFacets.set(facets);
					this.selection.searchFacets.itemTotal = result.size;

					this.pager.set({
						itemTotal: result.size,
					});
				}

				return assets;
			},
		};
	}

	/** @override */
	constructor(models, opts = {}) {
		super(models, opts);

		// DAM-19030 - there's gotta be a better way, but for now...
		if (isMobile(false, 601)) {
			this.pager.set({pagesToDisplay: 6});
		}

		// parse method?
		this.on('sync', (result, options) => {
			dispatcher.trigger('search:facet:onOff', this);
		});
	}

	/**
	 * Determine if this collection is the one referred to in the route hash
	 * Overriding to check for routeContext.length, so asset.cursor doesn't fetch with every search
	 * @override
	 */
	hasRouteContext() {
		const {hash} = window.location;
		const unescapedHash = unescapeURI(window.location.hash);
		const routeContext = this.routeContext;
		// Check for unescaped and escaped
		return (
			routeContext.length &&
			// DAM-19489 DAM-19485 - hash with "cart-assets" gives a
			// false positives for a routeContext of "cart"
			(routeContext !== 'cart' || routeContext === hash) &&
			(unescapedHash.indexOf(unescapeURI(routeContext)) > -1 ||
				unescapedHash.indexOf(escapeURI(routeContext)) > -1)
		);
	}
}
